module.exports = __webpack_public_path__ + "static/img/itzixun.1595f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/itzixun.png
// module id = FcX2
// module chunks = 1